import { Space } from "components/Common/Space";
import { Tooltip } from "components/Interactive/Tooltip";
import { useRole } from "hooks/common";
import { DroppableItem } from "../DroppableItem";
import {
  TExerciseIdentifier,
  TMakeWordFromLettersExerciseWordBlank,
} from "types/app/exercises";
import "./DroppableList.styles.scss";

type TDroppableListProps = {
  /**
   * An array of word blanks that will be rendered as droppable items.
   */
  blanks: TMakeWordFromLettersExerciseWordBlank[];
  /**
   * Text hint that will be available only for admin and teacher.
   */
  hint: string | null;
  /**
   * If the draggable element that is currently being dragged, the `dragging` property will be `true`.
   * @default false
   */
  dragging?: boolean;
  /**
   * Indicates whenever to show exercise results.
   * @default false
   */
  showResult?: boolean;
  /**
   * Currently dragged active item identifier.
   * @default null
   */
  dragActiveId?: TExerciseIdentifier | null;
  attemptsUsed?: number;
  isSuccessful?: boolean;
};

export const DroppableList: React.FC<TDroppableListProps> = (props) => {
  const {
    dragging = false,
    showResult = false,
    blanks = [],
    dragActiveId = null,
    hint,
  } = props;

  const { isUserStudent, isUserTeacher } = useRole();

  return (
    <Space
      direction="horizontal"
      size="x-small"
      justify="center"
      align="center"
      fullWidth
      wrap
    >
      <Tooltip
        text={hint}
        disabled={isUserStudent}
        trigger="hover"
        position="top-start"
        spaceSize="small"
        arrow="visible"
        containerClassName="nb-exercise-make-words-from-letters-tooltip-container"
        className="nb-exercise-make-words-from-letters-tooltip"
      >
        {blanks.map((blank) => (
          <DroppableItem
            key={blank.id}
            blank={blank}
            dragging={dragging || !isUserTeacher}
            dragActiveId={dragActiveId}
            showResult={showResult}
          />
        ))}
      </Tooltip>
      {/*<AttemptIndicator*/}
      {/*  attempts={attemptsUsed}*/}
      {/*  maxAttempts={3}*/}
      {/*  isSuccessful={isSuccessful}*/}
      {/*/>*/}
    </Space>
  );
};
